import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { getFirstAccessibleRoute } from '../../config/routes';

const RedirectToFirstAccessibleRoute: React.FC = () => {
  const { hasPermission, user, isLoading } = useAuth();

  if (isLoading) {
    return null; // Will be handled by ProtectedRoute
  }

  const isSuperAdmin = user?.role?.toLowerCase() === 'super_admin';
  const redirectPath = getFirstAccessibleRoute(hasPermission, isSuperAdmin);

  return <Navigate to={redirectPath} replace />;
};

export default RedirectToFirstAccessibleRoute;

